import lang from '@/lang'
import { receiptStates } from '@/modules/base/util/constants'
import { REVIEW_ROW_TERMINAL_STATE } from '@/modules/document/utils/invoice-analysis-state'

const {
  IN_PROGRESS,
  PAID,
  PARTIALLYPAID,
  ISOVERDUE,
  ISDUE,
  DRAFT,
  TO_ANALYZE,
  ANALYZE_ERROR,
} = receiptStates

export const getReceiptState = (state) => {
  switch (state) {
    case IN_PROGRESS:
      return lang.inProgress
    case PAID:
      return lang.paid
    case PARTIALLYPAID:
      return lang.partlyPaid
    case ISOVERDUE:
      return lang.overdue
    case ISDUE:
      return lang.due
    case DRAFT:
      return lang.toCheck
    case TO_ANALYZE:
      return lang.toAnalyze
    case ANALYZE_ERROR:
      return lang.analyzeError
    // FLAG:useDocuAi — the two verdicts a record inherits from its linked file (T8 of plan
    // omxweb-draft-receipt-instead-of-review-row); a flag-OFF row never carries them.
    case REVIEW_ROW_TERMINAL_STATE.ANALYSIS_ABORTED:
      return lang.documents.invoiceAnalysisAborted
    case REVIEW_ROW_TERMINAL_STATE.NO_INVOICE_FOUND:
      return lang.documents.invoiceAnalysisNoInvoice
    default:
      return lang.open
  }
}

export const getReceiptStateColor = (state) => {
  switch (state) {
    case IN_PROGRESS:
      return 'purple'
    case PARTIALLYPAID:
      return 'lightBlue'
    case PAID:
      return 'green'
    case ISOVERDUE:
      return 'red'
    case ISDUE:
      return 'orange'
    case DRAFT:
      return 'yellow'
    default:
      return 'blue'
  }
}
